{
  "notifications": "Notificaciones",
  "send-new": "Enviar nueva",
  "compose": "Redactar",
  "select-recipients": "Seleccionar destinatarios",
  "no-matching-contacts": "No se encontraron contactos",
  "template": "Plantilla",
  "subject": "Asunto",
  "to": "A",
  "cc": "CC",
  "bcc": "CCO",
  "reply-to": "Responder a",
  "send": "Enviar",
  "message": "Mensaje",
  "options": "Opciones",
  "date": "Fecha y hora",
  "sender": "Remitente",
  "recipients": "Destinatarios",
  "status": "Estado",
  "status-sent": "Enviado",
  "from": "De",
  "send-notification": "Notificación enviada con éxito",
  "view-message": "Ver mensaje",
  "no-notifications": "Aún no se han enviado notificaciones para esta orden.",
  "preview": "Vista previa"
}
